const steps_carousel = () => {

    $('.steps--carousel-slider').on('init', function(){
        var bg_ele =  $(this).parents('.steps--carousel').find('.steps-carousel-bg')
        bg_ele.data('currentRotation', '0')

    })

    var carousel = $('.steps--carousel-slider').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        nextArrow: '.steps--carousel-next',
        prevArrow: ''
    });


    carousel.on("beforeChange", function (){
        var bg_ele =  $(this).parents('.steps--carousel').find('.steps-carousel-bg')
        var rotation = parseInt(bg_ele.data('currentRotation')) + 360
        bg_ele.data('currentRotation', rotation)
        bg_ele.css('transform', 'rotate('+rotation+'deg)')
    })
};

export default steps_carousel;